import { render } from "./VisitList.vue?vue&type=template&id=3f3c97ac"
import script from "./VisitList.vue?vue&type=script&lang=js"
export * from "./VisitList.vue?vue&type=script&lang=js"
script.render = render

export default script